export default "__VITE_ASSET__a8cda5ca__"